import React from 'react';

const MassExpandContext = React.createContext(false);

export default MassExpandContext;